import { render, staticRenderFns } from "./ResourceDownload.vue?vue&type=template&id=acb820bc"
import script from "./ResourceDownload.vue?vue&type=script&lang=js"
export * from "./ResourceDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports